<template>

	<v-content>
		<v-container fluid >
			<v-layout row>


				<template v-if="isLoading">
					<div class="text-xs-center pa-5 loadingSpinnerContainer">
						<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
						<div class="caption mt-4">Liste yükleniyor</div>
					</div>
				</template>

				<template v-if="!isLoading">

					<div class="CekilisDetail">

						<div class="f-cols">

							<div class="f-col">

								<div class="media-embed">
									<div class="media-owner">
										<div class="logo">
											<img :src="cekilis.post_user_profile" alt="">
										</div>
										<div class="name">
											<div class="username">
												<a
													:href="'https://www.instagram.com/'+cekilis.post_user_username">{{cekilis.post_user_username}}</a>
											</div>
											<div class="fullname"> Yamaner Kuyumculuk </div>
										</div>
									</div>
									<div class="media-counts">
										<div class="media-count">
											<div class="number">{{cekilis.count_followers}}</div>
											<div class="label">takipçi</div>
										</div>
										<div class="media-count">
											<div class="number">{{cekilis.count_likes}}</div>
											<div class="label">beğeni</div>
										</div>
										<div class="media-count">
											<div class="number">{{cekilis.count_comments}}</div>
											<div class="label">yorum</div>
										</div>
										<div class="media-count">
											<div class="number">{{cekilis.count_attachs}}</div>
											<div class="label">etiket</div>
										</div>
									</div>
									<div class="media-data">
										<img :src="cekilis.post_image" alt="">
									</div>
									<div class="media-text" v-html="cekilis.post_text"></div>
								</div>


							</div>




							<div class="f-col">
								<div class="scanner">
									<v-btn :loading="isLoadingFollowers" :disabled="isLoadingFollowers"
										color="secondary" @click="loadFollowers()"> Takipçiler </v-btn>
									<v-btn :loading="isLoadingLikers" :disabled="isLoadingLikers" color="secondary"
										@click="loadLikers()"> Beğenenler </v-btn>
									<v-btn :loading="isLoadingComments" :disabled="isLoadingComments" color="secondary"
										@click="loadComments()"> Yorumlar </v-btn>
								</div>

								<div class="rules">
									<v-checkbox v-model="rules.attach_lucky" color="indigo"
										label="Kişi etiketlemek şansı arttırır" hide-details></v-checkbox>
									<v-checkbox v-model="rules.unique_winner" color="indigo" label="Aynı kişi olamaz"
										hide-details>
									</v-checkbox>
									<v-text-field v-model="rules.max_win_day" class="mt-3"
										label="Bu kadar gün içinde kazanmamış olmalı" outline type="number"
										hide-details></v-text-field>
									<v-text-field v-model="rules.min_attach_count" class="mt-3"
										label="En az etiketlediği kişi sayısı" outline type="number" hide-details>
									</v-text-field>
									<v-combobox class="mt-3" v-model="rules.contain_comments" outline hide-selected
										label="Yorumlar şunlardan birini içermeli" multiple persistent-hint small-chips
										hide-details></v-combobox>

									<v-text-field v-model="result_slots_count" class="mt-3"
										label="Şu kadar sonuç çıkacak" outline type="number" hide-details>
									</v-text-field>

									<v-btn class="mt-3" :loading="isLoadingFilters" :disabled="isLoadingFilters"
										color="indigo" dark @click="loadFilters()"> Filtrele </v-btn>
								</div>


							</div>



							<div class="f-col">

								<div class="sonuclar">
									<div class="head">
										<b>{{result_counts.tekil}}</b> tekil - <b>{{result_counts.cogul}}</b> çoğul
										katılımcı
									</div>
									<div class="users">
										<div class="user" v-for="(result_slot,result_slotIndex) in result_slots"
											:key="'resultUser'+result_slotIndex">
											<div class="user-detail" v-if="result_slot.user !== null">
												<div class="logo">
													<img :src="result_slot.user.user_picture" alt="">
												</div>
												<div class="name">
													<div class="username"><a
															:href="'https://www.instagram.com/'+result_slot.user.user_username" target="_blank">{{result_slot.user.user_username}}</a>
													</div>
													<div class="fullname">{{result_slot.user.user_fullname}}</div>
													<div class="uyari" v-if="result_slot.user.isWinBefore">
														{{result_slot.user.isWinBefore}} da kazandı</div>
												</div>
												<div class="action">
													<v-btn flat icon color="default" @click="displaySlot(result_slotIndex)">
														<v-icon>remove_red_eye</v-icon>
													</v-btn>
												</div>
												<div class="action">
													<v-btn flat icon color="pink" @click="clearSlot(result_slotIndex)">
														<v-icon>clear</v-icon>
													</v-btn>
												</div>
											</div>
											<div class="mixer" v-if="result_slot.user === null">
												<v-btn :loading="result_slot.isLoading" color="pink" dark
													@click="reloadSlot(result_slotIndex)"> GETİR </v-btn>
											</div>
										</div>
									</div>
									<v-btn class="mt-3 mb-4" :loading="isLoadingSave" :disabled="isLoadingSave" color="success"  
										@click="saveResults()"> LİSTEYİ KAYDET </v-btn>
								</div>

							</div>


							<div class="f-col-x">

							</div>
						</div>

					</div>

				</template>


				<v-dialog v-model="result_dialog_slot_show" scrollable max-width="400px"> 
					<v-card>
						<v-card-title>Kullanıcı Bilgileri</v-card-title>
						<v-divider></v-divider>
						<v-card-text style="height: 500px;" v-if="result_dialog_slot_show">
							<div class="CekilisSlotDetails"> 
								<div class="user-detail" >
									<div class="logo">
										<img :src="result_dialog_slot.user_picture" alt="">
									</div>
									<div class="name">
										<div class="username"><a :href="'https://www.instagram.com/'+result_dialog_slot.user_username" target="_blank">{{result_dialog_slot.user_username}}</a>
										</div>
										<div class="fullname">{{result_dialog_slot.user_fullname}}</div>
										<div class="uyari" v-if="result_dialog_slot.isWinBefore"> {{result_dialog_slot.isWinBefore}} da kazandı</div>
									</div> 
								</div>
								<div class="slotForsCount">
									{{result_dialog_slot.comments_count}} Yorum - {{result_dialog_slot.attachs_count}} Etiket
								</div>
								<div class="slotFors">
									<div class="slotForsLabel">Şu yorum ile öne çıktı</div>
									<div class="slotForsText">{{result_dialog_slot.for_comment}}</div>
								</div>
								<div class="slotFors">
									<div class="slotForsLabel">Şu yorum ile öne çıktı</div>
									<div class="slotForsText">@{{result_dialog_slot.for_attach}}</div>
								</div>
								<div class="slotComments">
									<div class="slotCommentsTitle">Yorumları</div>
									<div class="slotCommentsText" v-for="(slotComment,slotCommentIndex) in result_dialog_slot.comments" :key="'slotCommentIndex'+slotCommentIndex">{{slotComment}}</div>
								</div>
								<div class="slotAttachs">
									<div class="slotCommentsTitle">Etiketledikleri</div>
									<a class="slotAttachsText" v-for="(slotAttach,slotAttachIndex) in result_dialog_slot.attachs" :key="'slotAttachIndex'+slotAttachIndex" href="'https://www.instagram.com/'+slotAttach" target="_blank">{{slotAttach}}</a>
								</div>
							</div>
						</v-card-text>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn color="blue darken-1" flat @click="result_dialog_slot_show = false">Kapat</v-btn> 
						</v-card-actions>
					</v-card>
				</v-dialog>





			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "SocialmediaCekilisIndex",
		components: {},
		data() {
			return {
				isLoading: true,
				cekilis: {
					id: "1",
					brand_id: "",
					name: "",
					post_url: "",
					post_id: "",
					post_pk: "",
					post_username: "",
					post_image: "",
					post_text: " başlıyor "
				},
				isLoadingPostInfo: false,
	 

				isLoadingFollowers: false,
				isLoadingLikers: false,
				isLoadingComments: false,
				rules: {
					attach_lucky: true,
					unique_winner: true,
					max_win_day: 90,
					min_attach_count: 1,
					contain_comments: [],
				},
				isLoadingFilters: false,
				result_counts: {
					tekil: 0,
					cogul: 0
				},
				result_slots: [],
				result_slots_count: 4,
				result_dialog_slot : null,
				result_dialog_slot_show : false,
				isLoadingSave : false
			}
		},
		mounted() {
			this.loadInfo();
		},
		methods: {
			loadInfo() {
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/info", {
					params: {
						id: this.$route.query.id
					}
				}).then(response => {
					this.cekilis = response.body;
					this.isLoading = false;
				})
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/results/info", {
					params: {
						cekilis_id: this.$route.query.id
					}
				}).then(response => {
					if(response.body.success){
						this.rules = response.body.record.rules
						this.result_slots = response.body.record.result_slots
						this.result_slots_count = response.body.record.result_slots_count
					}
				})
			},
			loadFollowers() {
				this.isLoadingFollowers = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/scan/followers", {
					params: {
						id: this.$route.query.id
					}
				}).then(response => {
					// this.brands = response.body;
					this.isLoadingFollowers = false;
					this.loadInfo();
				})
			},
			loadLikers() {
				this.isLoadingLikers = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/scan/likers", {
					params: {
						id: this.$route.query.id
					}
				}).then(response => {
					// this.brands = response.body;
					this.isLoadingLikers = false;
					this.loadInfo();
				})
			},
			loadComments() {
				this.isLoadingComments = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/scan/comments", {
					params: {
						id: this.$route.query.id
					}
				}).then(response => {
					// this.brands = response.body;
					this.isLoadingComments = false;
					this.loadInfo();
				})
			},
			loadFilters() {
				this.isLoadingFilters = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/filtredusers", {rules : this.rules,result_slots : this.result_slots}, {
					params: {
						id: this.$route.query.id
					}
				}).then(response => {
					this.result_counts = response.body;
					this.isLoadingFilters = false;
					var newUsers = [];
					for (var i = 0; i < this.result_slots_count; i++) {
						if (this.result_slots.length > i) {
							this.result_slots[i].isLoading = false;
							newUsers.push(this.result_slots[i])
						} else {
							newUsers.push({
								isLoading: false,
								user: null
							})
						}

					}
					this.result_slots = newUsers;
				})
			},
			reloadSlot(result_slotIndex) {
				this.result_slots[result_slotIndex].isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/filtredusers", {rules : this.rules,result_slots : this.result_slots}, {
					params: {
						id: this.$route.query.id,
						get_one: 1
					}
				}).then(response => {
					this.result_slots[result_slotIndex].isLoading = false;
					if(response.body.success){
						this.result_slots[result_slotIndex].user = response.body.user;
					}
					
				})
			},
			clearSlot(result_slotIndex) {
				this.result_slots[result_slotIndex].isLoading = false;
				this.result_slots[result_slotIndex].user = null;
			},
			displaySlot(result_slotIndex) { 
				this.result_dialog_slot = this.result_slots[result_slotIndex].user;
				this.result_dialog_slot_show = true;
			},
			editItem(item) {
				if (item) {
					this.item = JSON.parse(JSON.stringify(item))
				} else {
					this.item = {
						id: "",
						name: "",
						brand_id: "",
						post_url: "",
						post_id: "",
						post_pk: "",
						post_username: "",
						post_image: "",
						post_text: ""
					}
				}
				this.dialogEditor = true;
			},

			saveResults() { 
				this.isLoadingSave = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cekilis/results/save", {

					rules: this.rules,
					result_slots: this.result_slots,
					result_slots_count: this.result_slots_count,
				}, {
					params: {
						cekilis_id: this.$route.query.id,
					}
				}).then(response => {
					this.isLoadingSave = false;
				})
			},

		},
		computed: { 
		}
	}
</script>



<style lang="less">
	.loadingSpinnerContainer {
		width: 100%;
	}

	.CekilisDetail {
		.f-cols {
			display: flex;

			.f-col {
				margin-right: 15px;
			}

			.f-col-x {
				flex: 1;
			}
		}

		.media-embed {
			width: 400px;
			background: #fff;
			box-shadow: 0 0 5px #aaa;
			border-radius: 3px;

			.media-owner {
				display: flex;
				width: 100%;
				align-items: center;

				.logo {
					padding: 5px;

					img {
						object-fit: cover;
						width: 40px;
						height: 40px;
						display: block;
					}
				}

				.name {
					.username {
						padding-left: 10px;

						a {
							display: block !important;
							font-weight: 500;
							text-decoration: none;
						}
					}

					.fullname {
						display: none;
					}
				}
			}

			.media-counts {
				display: flex;
				border-top: 1px solid #ddd;
				padding-top: 10px;
				padding-bottom: 10px;

				.media-count {
					flex: 1;

					&:not(:first-child) {
						border-left: 1px solid #ddd;
					}

					.number {
						text-align: center;
						font-weight: 500;
					}

					.label {
						text-align: center;
						font-size: 12px;
					}
				}
			}

			.media-data {
				img {
					width: 100%;
				}
			}

			.media-text {
				padding: 12px;
			}
		}


		.scanner {
			text-align: center;
			width: 405px;
			background: #fff;
			box-shadow: 0 0 5px #aaa;
			border-radius: 3px;
			padding: 10px;
		}

		.rules {
			text-align: center;
			width: 405px;
			background: #fff;
			box-shadow: 0 0 5px #aaa;
			border-radius: 3px;
			padding: 10px;
			margin-top: 15px;
		}

		.sonuclar {
			text-align: center;
			width: 405px;
			background: #fff;
			box-shadow: 0 0 5px #aaa;
			border-radius: 3px;

			// margin-top: 15px;
			.head {
				padding: 10px;
			}

			.users {
				border-top: 1px solid #ccc;
				padding: 10px;

				.user {
					width: 100%;
					min-height: 50px;
					background: #eee;
					border: 2px dashed #ddd;

					&:not(:first-child) {
						margin-top: 15px;
					}

					.user-detail {
						display: flex;
						width: 100%;
						align-items: center;

						.logo {
							padding: 5px;

							img {
								object-fit: cover;
								width: 40px;
								height: 40px;
								display: block;
							}
						}

						.name {
							flex: 1;
							text-align: left;

							.username {
								padding-left: 10px;

								a {
									display: block !important;
									font-weight: 500;
									text-decoration: none;
									padding: 0px;
									margin: 0px;
									text-align: left;
								}
							}

							.fullname {
								padding-left: 10px;
								text-align: left;
							}

							.uyari {
								text-align: left;
								padding-left: 10px;
								font-size: 12px;
								color: rgb(255, 115, 0);
							}
						}
					}
				}
			}
		}

	}


	.CekilisSlotDetails{
		.user-detail {
			display: flex;
			width: 100%;
			align-items: center;

			.logo {
				padding: 5px;

				img {
					object-fit: cover;
					width: 40px;
					height: 40px;
					display: block;
				}
			}

			.name {
				flex: 1;
				text-align: left;

				.username {
					padding-left: 10px;

					a {
						display: block !important;
						font-weight: 500;
						text-decoration: none;
						padding: 0px;
						margin: 0px;
						text-align: left;
					}
				}

				.fullname {
					padding-left: 10px;
					text-align: left;
				}

				.uyari {
					text-align: left;
					padding-left: 10px;
					font-size: 12px;
					color: rgb(255, 115, 0);
				}
			}
		}
		.slotForsCount{
			text-align: center;
			font-size:12px;
			border-top:1px dashed #ccc;
			padding-top:10px;
			margin-top:15px;
		}
		.slotFors{
			margin-top:10px;
			background-color: rgb(247, 245, 129);
			padding : 8px;
			.slotForsLabel{
				font-weight: 500;
				font-size:12px;
			}
			.slotForsText{
				color : rgb(13, 92, 5);
				font-weight: 700;
			}
		}
		.slotComments{
			// border:1px solid #ccc;
			margin-top:10px;
			.slotCommentsTitle{
				text-align: center;
				font-weight: 500;
			}
			.slotCommentsText{
				background-color: rgb(243, 242, 197);
				font-weight: 500;
				font-size:12px;
				padding: 4px;
				&:not(:last-child){
					border-bottom:1px dashed #ccc;
				}
			}
		}
		.slotAttachs{
			// border:1px solid #ccc;
			margin-top:10px;
			width: 100%;
			text-align: center;
			.slotCommentsTitle{
				font-weight: 500;
			}
			.slotAttachsText{
				display: inline-block;
				margin-right:5px;
				background-color: rgb(4, 74, 224);
				color:#fff;
				font-size:11px;
				line-height: 15px;
				padding:3px 8px;
				text-decoration: none;
				border-radius: 12px;
				margin-bottom:3px;
			}
		}
	}
</style>